<template>
    <v-menu offset-y>
        <template v-slot:activator="{on}">
            <v-btn
                text v-on="on"
                color="grey darken-3"
                dark
                class="rendezosav__btn"
            >
                <v-icon>sort</v-icon>
                <div class="rendezosav__btn__content">
                    <span class="font-weight-medium">{{ label }}</span>
                    <span>{{ selectedLabel }}</span>
                </div>
            </v-btn>
        </template>

        <v-list>
            <v-list-item
                avatar
                v-for="(item, index) in rendezesiModok"
                :key="index"
                @click="orderFn(index)"
            >
                <v-list-item-avatar>
                    <v-icon> {{item.icon}} </v-icon>
                </v-list-item-avatar>
                <v-list-item-title> {{ item.label }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'BnRendezoSav',
    props: {
        rendezesiModok: {
            type: Array,
            required: true,
        },

        label: {
            type: String,
            required: true,
        },

        value: {
            type: Number,
            default: null,
        },
    },

    methods: {
        orderFn(index) {
            this.rendezesiModok[index].orderFn();
            this.$emit('input', this.rendezesiModok[index].value);
            this.$emit('change', this.rendezesiModok[index].value);
        },
    },

    computed: {
        selectedLabel() {
            return this.rendezesiModok.find((element) => element.value === this.value)?.label || '-';
        },
    },
};
</script>

<style scoped>
    .rendezosav__btn {
        letter-spacing: normal;
        font-weight: 400;
    }

    .rendezosav__btn__content {
        margin-left: 8px;
        display: flex;
        flex-direction: column;
        align-items: start;
    }
</style>
